import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Groups replace the old dimmed "manual path" block. Nothing is ever dimmed now, so
  // there is no muted variant — the section's two halves are separate concerns shown
  // side by side, not alternatives competing for one slot.
  group: {
    marginTop: 16
  },
  groupLabel: {
    fontWeight: 700,
    marginBottom: 4
  },
  statusRow: {
    alignItems: 'center',
    display: 'flex',
    gap: 8,
    justifyContent: 'space-between',
    marginTop: 4,
    maxWidth: 420
  },
  totalRow: {
    alignItems: 'center',
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    gap: 8,
    justifyContent: 'space-between',
    marginTop: 16,
    maxWidth: 420,
    paddingTop: 8
  },
  totalAmount: {
    fontWeight: 700
  },
  card: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    marginTop: 16,
    padding: 16
  },
  title: {
    fontWeight: 700,
    marginBottom: 4
  },
  // The code field and its helper text read as one unit; the helper is doing real
  // work here rather than decorating, because nothing can validate the code until
  // the booker continues.
  codeRow: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 12,
    maxWidth: 320
  },
  // The field and its action on ONE row. They were stacked, which left the button
  // orphaned under a full-width field — the portal puts Apply beside its input, never
  // below it (portal-ux-conventions.md:226, the filter panel's Apply).
  codeFieldRow: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: 8,
    marginTop: 12,
    maxWidth: 420
  },
  codeField: {
    flex: 1
  },
  // Offset to the FIELD's height, not the text's. Without it the button sits against the
  // top of an input whose label has pushed it down.
  applyButton: {
    marginTop: 22,
    whiteSpace: 'nowrap'
  },
  // The applied state REPLACES the field. Leaving an editable input beside the word
  // "applied" invites an edit that silently invalidates the verdict shown next to it —
  // the same attribution problem usePromotionEvaluation fences against internally.
  appliedRow: {
    backgroundColor: theme.palette.action.hover,
    borderRadius: 8,
    marginTop: 12,
    maxWidth: 420,
    padding: '8px 12px'
  },
  appliedHeader: {
    alignItems: 'center',
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between'
  },
  appliedText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  // The saving is the point of the section, so it is the one thing allowed to be loud.
  // Success colour rather than the brand red, which reads as an error beside "applied".
  appliedAmount: {
    color: theme.palette.success.dark,
    fontWeight: 600
  },
  noCodeDiscount: {
    color: theme.palette.text.primary,
    fontWeight: 600
  },
  codeDiscountRow: {
    alignItems: 'baseline',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'space-between',
    marginTop: 8
  },
  allocationList: {
    borderInlineStart: `2px solid ${theme.palette.grey[400]}`,
    marginBlockEnd: 12,
    marginBlockStart: 4,
    marginInlineEnd: 12,
    marginInlineStart: 8,
    paddingBlock: 2,
    paddingInlineStart: 12
  },
  allocationRow: {
    alignItems: 'baseline',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'space-between',
    minHeight: 20
  },
  // Automatic and manual are alternatives, not siblings. Dimmed rather than unmounted so
  // the booker can see the choice they are not taking.
  manualPath: {
    transition: 'opacity 150ms'
  },
  manualPathMuted: {
    opacity: 0.45,
    pointerEvents: 'none'
  },
  manualPathHint: {
    color: theme.palette.text.secondary,
    marginTop: 8
  },
  // A discount is a number; it was rendered as a fragment of the offer's label. Pulled out
  // so offers can be compared down a column instead of read one sentence at a time.
  offerDiscount: {
    color: theme.palette.success.dark,
    fontWeight: 700,
    marginLeft: 8
  },
  helper: {
    color: theme.palette.text.secondary,
    marginTop: 4
  },
  refusal: {
    color: theme.palette.error.dark,
    marginTop: 4
  },
  // Warning rather than secondary text: this line is the difference between an offer
  // that will apply and one that will not, so it must not read as more fine print.
  blocker: {
    color: theme.palette.warning.dark,
    marginTop: 4
  },
  automaticRow: {
    alignItems: 'center',
    display: 'flex'
  },
  offers: {
    marginTop: 8
  },
  offersLabel: {
    color: theme.palette.text.secondary,
    marginBottom: 4
  },
  offersLoading: {
    padding: '8px 0'
  },
  offerRow: {
    alignItems: 'flex-start',
    cursor: 'pointer',
    display: 'flex'
  },
  offerText: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 9
  }
}))

export default useStyles
